import { IApplicationAPI } from "@ffld/domain";
import { createContext } from "react";

const ApplicationKey = {
    legoDigitalDesigner: "lddapp",
    lddlauncher: "lddlauncher",
}
const ApplicationContext = createContext({} as IApplicationAPI)

export { ApplicationKey, ApplicationContext };